const t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.5 0h-13A2.5 2.5 0 0 0 3 2.5v19A2.5 2.5 0 0 0 5.5 24h13a2.5 2.5 0 0 0 2.5-2.5v-19A2.5 2.5 0 0 0 18.5 0Zm.5 18.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 18.5v-13A1.5 1.5 0 0 1 6.5 4h11A1.5 1.5 0 0 1 19 5.5Z" fill="currentColor"></path></svg>';
export {
  t as default
};
